<template>
  <v-dialog v-model="dialog" max-width="900px" persistent>
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Invoice Preview - {{ invoice.INVOICE_ID }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="print" title="Print Invoice">
          <v-icon>mdi-printer</v-icon>
        </v-btn>
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-0">
        <div class="invoice-preview">
          <invoice-print :invoice="invoice" ref="invoicePrint" />
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Close</v-btn>
        <v-btn color="primary" @click="print">
          <v-icon left>mdi-printer</v-icon>
          Print Invoice
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InvoicePrint from './InvoicePrint.vue';

export default {
  name: 'InvoicePreview',
  components: {
    InvoicePrint,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    invoice: {
      type: Object,
      required: true
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    print() {
      if (this.$refs.invoicePrint) {
        this.$refs.invoicePrint.print();
      }
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
.invoice-preview {
  background: white;
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

@media print {
  .invoice-preview {
    max-height: none;
    overflow: visible;
  }
}
</style>




